import { PageWrapper, SecondaryNav, rem } from '@innovyze/stylovyze';
import { Paper, Typography } from '@mui/material';
import styled from 'styled-components';

export const PageWrapperStyled = styled(PageWrapper)`
	/*&& > div:nth-child(-n + 1) {
		z-index: 9999;
		top: 0px;
		position: sticky;
		background-color: #f9fafc;
	}*/
`;

export default PageWrapperStyled;

export const NewSensorPageStyled = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

export const Title = styled(Typography)`
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 32px;
	margin-top: 15px;
	color: #252f33;
	padding: 5px 0px 5px 0px;
`;

export const PaperStyled = styled(Paper)`
	display: flex;
	flex-direction: column;
	margin-top: 30px;
`;

export const NavStyled = styled(SecondaryNav)`
	border-bottom-color: #768d95;
`;

export const MapCardStyle = styled('div')`
	height: 400px;
`;

export const ChartCard = styled.div`
	min-height: 480px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const SensorStatusWrapper = styled.div`
	width: auto;
	height: auto;
	min-width: 35px;
	min-height: 35px;
`;

export const MenuGrid = styled.div`
	display: grid;
	grid-template-columns: auto auto auto auto;
	grid-gap: ${rem(8)};
`;

export const StyledControlsWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const StyledStatusIndicatorWrapper = styled.div`
	display: flex;
	padding: 9px;
	gap: 11px;
	color: #879ba2;
	align-items: center;
`;
